export enum Customer_CustomerGender {
  UNSPECIFIED = 0,
  FEMALE = 1,
  MALE = 2,
  DIVERSE = 3,
  NEUTRAL = 4,
}

export interface Customer {
  id: number;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email: string;
  // used for tracking providers
  emailHash: string;
  birthday?: Date;
  // customer has not ordered yet
  isNewCustomer: boolean;
  customerGender: Customer_CustomerGender;
  authenticationMethod: Customer_AuthenticationMethod;
}

export interface Customer_AuthenticationMethod {
  // "password", "apple", "facebook", "google", "klarna"
  type: string;
}
